import { useState } from 'react';
import PricingTables from './PricingTable';
import AcademicApplicationModal from '../Academic/AcademicApplicationModal';
import { userAppContext } from '../../context/Context';
import { useAcademicApplication } from '../../hooks/useAcademicApplication';
import { UserContext } from '../../types';
import BackgroundPages from '@/global/Background/BackgroundPages';

function PricingTablesAcademic() {
  const [isTableExpanded, setIsTableExpanded] = useState(true);
  const [showModalAcademic, setShowModalAcademic] = useState(false);
  const { user, isAuthenticated } = userAppContext() as unknown as UserContext;
  const { submitAcademicApplication, academicStatus } = useAcademicApplication(user?.email, isAuthenticated);

  return (
    <>
      <BackgroundPages />
      <div className="PricingApp">
        <div className="app-container md:px-16 lg:px-40">
          <PricingTables
            activeTab="academic"
            isExpanded={isTableExpanded}
            onToggleExpand={() => setIsTableExpanded(prev => !prev)}
            onAcademicApply={() => setShowModalAcademic(true)}
            showColumnPrices
            columnIds={['standard', 'advanced']}
          />
        </div>
      </div>
      {/* @ts-ignore */}
      <AcademicApplicationModal
        isOpen={showModalAcademic}
        onClose={() => setShowModalAcademic(false)}
        onSubmit={submitAcademicApplication}
        academicStatus={academicStatus}
      />
    </>
  );
}

export default PricingTablesAcademic;
